import React from 'react';
import classnames from 'classnames';

export type PillProps = {
  variant?: 'gray' | 'secondary' | 'red' | 'orange' | 'emerald';
  wrap?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export const Pill = ({
  variant = 'gray',
  wrap,
  className,
  children,
}: PillProps) => {
  return (
    <span
      className={classnames(
        'inline-block px-2 py-1 rounded-lg text-xs font-medium',
        {
          'whitespace-nowrap': !wrap,
        },
        {
          'bg-gray-100 text-gray-700': variant === 'gray',
          'bg-secondary-200 text-secondary-800': variant === 'secondary',
          'bg-red-200 text-red-800': variant === 'red',
          'bg-orange-200 text-orange-800': variant === 'orange',
          'bg-emerald-200 text-emerald-800': variant === 'emerald',
        },
        className
      )}
    >
      {children}
    </span>
  );
};
